import { client } from "./index";

// Franchise partners and their bulk website purchases (/api/admin/franchisees)
export const getFranchisees = (params) => client.get("/admin/franchisees", { params });
export const createFranchisee = (payload) => client.post("/admin/franchisees", payload);
export const updateFranchisee = (franchiseId, payload) => client.put(`/admin/franchisees/${franchiseId}`, payload);
// Super Admin only. confirmName must repeat the partner's name, as typed in the confirmation dialog.
export const deleteFranchisee = (franchiseId, confirmName) => client.delete(`/admin/franchisees/${franchiseId}`, { data: { confirmName } });
export const bulkPurchaseWebsites = (payload) => client.post("/admin/franchisees/bulk-purchase", payload);
export const getBulkPurchases = (params) => client.get("/admin/franchisees/bulk-purchases", { params });
